import api from "../api";

// Feature Flags
export const getFeatureFlags = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/feature-flags", { params });
};

export const getFeatureFlag = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/feature-flags/${id}`);
};

export const createFeatureFlag = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "admin/feature-flags", data);
};

export const updateFeatureFlag = async (id, data) => {
  return api.getApi().put(api.getBaseUrl() + `admin/feature-flags/${id}`, data);
};

export const toggleFeatureFlag = async (id) => {
  return api.getApi().post(api.getBaseUrl() + `admin/feature-flags/${id}/toggle`);
};

export const deleteFeatureFlag = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `admin/feature-flags/${id}`);
};

// Remote Config
export const getRemoteConfigs = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/remote-configs", { params });
};

export const getRemoteConfig = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/remote-configs/${id}`);
};

export const createRemoteConfig = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "admin/remote-configs", data);
};

export const updateRemoteConfig = async (id, data) => {
  return api.getApi().put(api.getBaseUrl() + `admin/remote-configs/${id}`, data);
};

export const deleteRemoteConfig = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `admin/remote-configs/${id}`);
};

// App Versions
export const getAppVersions = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/app-versions", { params });
};

export const getAppVersion = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/app-versions/${id}`);
};

export const createAppVersion = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "admin/app-versions", data);
};

export const updateAppVersion = async (id, data) => {
  return api.getApi().put(api.getBaseUrl() + `admin/app-versions/${id}`, data);
};

export const deleteAppVersion = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `admin/app-versions/${id}`);
};

// Devices
export const getDevices = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/devices", { params });
};

export const getDevice = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/devices/${id}`);
};

export const getDeviceStats = async () => {
  return api.getApi().get(api.getBaseUrl() + "admin/devices/stats");
};

export const getUserDevices = async (userId) => {
  return api.getApi().get(api.getBaseUrl() + `admin/users/${userId}/devices`);
};

export const banDevice = async (id, reason) => {
  return api.getApi().post(api.getBaseUrl() + `admin/devices/${id}/ban`, { reason });
};

export const unbanDevice = async (id) => {
  return api.getApi().post(api.getBaseUrl() + `admin/devices/${id}/unban`);
};

export const deleteDevice = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `admin/devices/${id}`);
};

// Note: Push Notification functions moved to push-notification-requests.js
// to avoid conflicts and use correct endpoints (/push-notifications instead of /admin/push-notifications)

